import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface PolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
}
export function PolicyModal({
  isOpen,
  onClose,
  title
}: PolicyModalProps) {
  return <AnimatePresence data-id="element-108">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-slate-dark/40 backdrop-blur-sm z-[60]" data-id="element-109" />
          <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl bg-white rounded-3xl shadow-2xl z-[70] p-6 md:p-8 max-h-[80vh] flex flex-col" data-id="element-110">
            <div className="flex justify-between items-center mb-6" data-id="element-111">
              <h3 className="text-2xl font-serif font-bold text-slate-dark" data-id="element-112">
                {title}
              </h3>
              <button onClick={onClose} className="p-2 bg-zen-beige rounded-full hover:bg-slate-dark/10 transition-colors" data-id="element-113">
                <XIcon className="w-5 h-5 text-slate-dark" data-id="element-114" />
              </button>
            </div>
            <div className="overflow-y-auto pr-2 text-slate-dark/70 space-y-4 text-sm md:text-base" data-id="element-115">
              <p data-id="element-116">
                Este es un texto legal de marcador de posición para {title}. En
                un entorno de producción real, aquí irían las cláusulas
                detalladas sobre la recopilación de datos, el uso del sitio web,
                las políticas de reembolso y otras consideraciones legales
                pertinentes.
              </p>
              <p data-id="element-117">
                Mascota Genial® se compromete a proteger la privacidad de sus
                usuarios y a proporcionar un servicio transparente y de alta
                calidad.
              </p>
              <p data-id="element-118">
                Para cualquier consulta relacionada con estos términos, por
                favor contacte a nuestro equipo de soporte.
              </p>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}